import "./styles.scss";

export const ErrorMessage = ({ message }: { message?: string | null }) => {
  if (!message) return null;
  return (
    <div className="error-container">
      <div className="error-message">
        <span>{message}</span>
      </div>
    </div>
  );
};
